<script>
import WebLayout from '@/layouts/Web/Layout.vue'

export default {
    layout: WebLayout,
}
</script>

<script setup>
import LegalDocument from '@/components/LegalDocument.vue'
</script>

<template>
    <LegalDocument translation-key="data_retention" route-name="web.data-retention" />
</template>
